import { render } from "./GrantCriteriaListNone.vue?vue&type=template&id=abb147b0&scoped=true&ts=true"
import script from "./GrantCriteriaListNone.vue?vue&type=script&lang=ts"
export * from "./GrantCriteriaListNone.vue?vue&type=script&lang=ts"

import "./GrantCriteriaListNone.vue?vue&type=style&index=0&id=abb147b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb147b0"]])

export default __exports__